import {
  ApiResponse,
  CancelReservedItemsSuccessResponseDto,
  OrderPaymentPartialSuccessResponseDto,
  OrderPaymentSuccessResponseDto,
  OrderRefundedPartialSuccessResponseDto,
  OrderRefundedSuccessResponseDto,
} from '@core/services/apiclient';

export type TransactionType = 'payment' | 'refund' | 'cancelReserved';

export interface PaymentResult {
  success: boolean;
  // Les issues d'erreur sont désormais des ProblemDetails (throw ApiException),
  // gérées par status code via TRANSACTION_ERROR_CONFIG ci-dessous.
  response:
    | ApiResponse<OrderPaymentSuccessResponseDto>
    | ApiResponse<OrderPaymentPartialSuccessResponseDto>
    | null;
  error?: unknown;
}

export interface RefundResult {
  success: boolean;
  // Les issues d'erreur sont désormais des ProblemDetails (throw ApiException),
  // gérées par status code via TRANSACTION_ERROR_CONFIG ci-dessous.
  response:
    | ApiResponse<OrderRefundedSuccessResponseDto>
    | ApiResponse<OrderRefundedPartialSuccessResponseDto>
    | null;
  error?: unknown;
}

export interface CancelReservedResult {
  success: boolean;
  response: ApiResponse<CancelReservedItemsSuccessResponseDto> | null;
  error?: unknown;
}

export interface TransactionResult<TResponse> {
  success: boolean;
  response: ApiResponse<TResponse> | null;
  error?: unknown;
}

export const SUCCESS_MESSAGES: Record<TransactionType, string> = {
  payment: 'orders.info.yourPaymentMadeSuccessfully',
  refund: 'orders.info.refundSuccessfully',
  cancelReserved: 'orders.info.cancellationSuccessfully',
};

export const DEFAULT_ERROR_MESSAGES: Record<TransactionType, string> = {
  payment: 'orders.info.yourPaymentCouldNotBeMade',
  refund: 'orders.info.refundFailed',
  cancelReserved: 'orders.info.cancelReservedFailed',
};

export const TRANSACTION_ERROR_CONFIG: Record<
  TransactionType,
  Record<number, { message: string; level: 'partialSuccess' | 'danger' }>
> = {
  payment: {
    207: { message: 'orders.info.paymentPartialSuccess', level: 'partialSuccess' },
    400: { message: 'orders.info.yourPaymentCouldNotBeMade', level: 'danger' },
    403: { message: 'orders.info.paymentRefused', level: 'danger' },
    404: { message: 'orders.payment.paymentNotFound', level: 'danger' },
    409: { message: 'orders.info.yourPaymentCouldNotBeMade', level: 'danger' },
    422: { message: 'orders.info.paymentAlreadyPaid', level: 'danger' },
    500: { message: 'orders.info.yourPaymentCouldNotBeMade', level: 'danger' },
  },
  refund: {
    207: { message: 'orders.info.refundPartialSuccess', level: 'partialSuccess' },
    400: { message: 'orders.info.refundFailed', level: 'danger' },
    403: { message: 'orders.info.refundRefused', level: 'danger' },
    404: { message: 'orders.info.refundNotFound', level: 'danger' },
    409: { message: 'orders.info.refundFailed', level: 'danger' },
    422: { message: 'orders.info.refundAlreadyRefunded', level: 'danger' },
    500: { message: 'orders.info.refundFailed', level: 'danger' },
  },
  cancelReserved: {
    207: { message: 'orders.info.cancelReservedPartialSuccess', level: 'partialSuccess' },
    400: { message: 'orders.info.cancelReservedFailed', level: 'danger' },
    409: { message: 'orders.info.cancellationAlreadyDone', level: 'danger' },
    422: { message: 'orders.info.cancelReservedFailed', level: 'danger' },
    500: { message: 'orders.info.cancelReservedFailed', level: 'danger' },
  },
};
